import '../App.css';

function AboutHome() {
  return (
    <div className='aboutMe'>
      <h2>Professional Summary</h2>
      <p>
        I build scalable products across mobile and web using Flutter, React, Next.js, and modern backend services.
        My work focuses on improving user experience while reducing latency, crash-prone states, and delivery risk.
      </p>
      <ul className="summary-list">
        <li>Own feature delivery from architecture and implementation to production deployment.</li>
        <li>Experienced with fintech, healthcare, social, and marketplace product domains.</li>
        <li>Strong in API integrations, performance optimization, and cross-platform release workflows.</li>
      </ul>
      <p>
        I enjoy working on products where technical quality directly improves customer trust and retention.
      </p>
      </div>
  );
}

export default AboutHome;
